<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="1.5" y="1.5" width="13" height="13" stroke="currentColor"/>
<path d="M9.5 1.5V14.5" stroke="currentColor"/>
<rect x="10" y="2" width="4" height="12" fill="currentColor"/>
</svg>
